export default [
  { name: 'ES', code: 'es' },
  { name: 'EN', code: 'en' }
]
